module.exports = __webpack_public_path__ + "img/user-astronaut.0a9b5b37.svg";